import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

import Vue from 'vue';
import Vuex from 'vuex';

import * as mutationTypes from './mutation-types';

//store modules
import objects3d from './modules/objects3d';
import mannequin from './modules/mannequin';
import shoes from './modules/shoes';
import camera from './modules/camera';
import fabrics from './modules/fabrics';
import textures from './modules/textures';
import clothes from './modules/clothes';
import snapshots from './modules/snapshots';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    initialized: false,
    title: '',
    basePath: '',
    canvas: null,
    scene: {
      inst: null,
      backgroundColor: null,//'#ffffff',
    },
    renderer: {
      inst: null
    },
    lights: [
      {
        target: new THREE.Vector3(0,50,0),
        color: "#ffffff",
        decay: 0.3,
        intensity: 1.0,
        distance: 1000,
        angle: 45,
        component: 'vgl-spot-light',
        position: new THREE.Vector3(400,300,400),
      },
      {
        color: "#ffffff",
        intensity: 0.3,
        component: 'vgl-hemisphere-light',
      }
    ], //todo create module lights
    loaders: {
      gltf: new GLTFLoader(),
      texture: new THREE.TextureLoader(),
    },
    loading: false,
  },
  getters: {
    loading: state => state.loading,
    canvas: state => state.canvas,
    scene: state => state.scene,
    renderer: state => state.renderer,
    lights: state => state.lights, //todo create module lights
    gltfLoader: state => state.loaders.gltf,
    title: state => state.title,
    initialized: state => state.initialized,
  },
  mutations: {
    [mutationTypes.INIT_VIEWPORT] ( state, { renderer, scene }) {
      state.renderer = renderer;

      // state.renderer.outputEncoding = THREE.sRGBEncoding;
      //set background transparent
      state.renderer.inst.setClearColor( 0x000000, 0 ); //todo try
      // state.renderer.inst.preserveDrawingBuffer = true;
      // let attributes = state.renderer.inst.getContextAttributes();
      // attributes.preserveDrawingBuffer = true;
      // console.log(state.renderer.inst.getContextAttributes());
      // console.log(state.renderer.inst);
      state.scene.inst = scene;
    },
    [mutationTypes.SET_PIXEL_RATIO] (state, devicePixelRatio) {
      state.renderer.inst.setPixelRatio(devicePixelRatio);
    },
    [mutationTypes.SET_SCENE_ENV] (state,texture) {
        texture.encoding = THREE.sRGBEncoding;
        texture.mapping = THREE.EquirectangularReflectionMapping;
        // state.scene.inst.environment = texture;
        state.scene.inst.needsUpdate = true;
    },
    [mutationTypes.SET_SCENE_BACKGROUND] (state, color) {
      state.scene.backgroundColor = color;
      state.scene.inst.needsUpdate = true;
    },
    [mutationTypes.RENDER] (state) {
      state.renderer.requestRender();
    },
    [mutationTypes.SET_TITLE] (state, title) {
      state.title = title;
    },
    [mutationTypes.SET_INIT_COMPLETED] (state) {
      state.initialized = true;
    }
  },
  actions: {
    setInitCompleted: ({ commit }) => {
      commit(mutationTypes.SET_INIT_COMPLETED);
    },
    initViewport: ({ commit, dispatch },payload) => {
      return new Promise( (resolve, reject) => {
        try {
          commit(mutationTypes.INIT_VIEWPORT,payload);
          commit(mutationTypes.SET_PIXEL_RATIO, payload.pixelRatio);

          dispatch('mannequin/setPoserInstance',payload.poser,{root:true}).then(() => {
            return dispatch('camera/initCamera',payload.camera,{root:true})
          })
          //   .then(() => {
          //
          //   return dispatch("setSceneEnv",'/textures/envmap-example.jpg')
          //   // return dispatch("setSceneEnv",'/wp-content/plugins/three-configurator/dist/textures/envmap-example.jpg')
          //
          // })
          //   .then(() => {
          //   let mannequin = rootGetters['mannequin/mannequin'];
          //   return dispatch('mannequin/uploadMannequin',mannequin,{root:true});
          //
          // })
            .then(() => {
            resolve(payload);
          });

        } catch (e) {
          reject(`An error happened: ${e}`)
        }
      })
    },
    setPixelRatio: ({ commit }, payload) => {
      commit(mutationTypes.SET_PIXEL_RATIO, payload);
    },
    setSceneEnv: ({ commit, state },payload) => {
      return new Promise( (resolve,reject) => {

        state.loaders.texture.load(
          payload,
          (texture) => {
            commit(mutationTypes.SET_SCENE_ENV,texture);
            resolve();
          },
          xhr => xhr.loaded / xhr.total * 100,
          error => {
            reject(`An error happened: ${error}`)
          }
        )
      })
    },
    setSceneBackgroundColor: ({ commit }, payload) => {
      return new Promise( (resolve,reject) => {
        try {
          commit(mutationTypes.SET_SCENE_BACKGROUND, payload);
          resolve(payload);
        } catch (e) {
          reject(`An error happened: ${e}`)
        }
      })
    },
    render: ({ commit }) => {
      // console.log('render');
      commit(mutationTypes.RENDER);
    },
    setTitle: ({ commit }, payload) => {
      commit(mutationTypes.SET_TITLE,payload);
    }
  },
  modules: {
    objects3d,
    mannequin,
    shoes,
    camera,
    fabrics,
    textures,
    clothes,
    snapshots
  }
})
